// Endpoint for API backend from environment
const endpoint = process.env.VUE_APP_ENDPOINT
export default endpoint;

